import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DisposalList, NoDisposals } from '../components';
import { 
  selectDisposals,
  selectIsFetching, 
  fetchDisposalsActions 
} from '../ducks';
import Button from 'antd/lib/button';

const mapStateToProps = state => ({
  disposals: selectDisposals(state).items,
  isFetching: selectDisposals(state).isFetching,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchDisposals: fetchDisposalsActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class DisposalsContainer extends Component {
  static propTypes = {
    disposals: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
    isFetching: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = { currentPage: 0 };
    this.nextButtonHandle = this.nextButtonHandle.bind(this);
    this.previousButtonHandle = this.previousButtonHandle.bind(this);
  }

  componentDidMount() {
    this.props.actions.fetchDisposals({
      pageSize: 20,
      pageNo: this.state.currentPage
    });
    document.documentElement.scrollTop = 0;
  }

  nextButtonHandle() {
    this.setState((state, props) => ({
      currentPage: state.currentPage + 1
    }));

    this.props.actions.fetchDisposals({
      pageSize: 20,
      pageNo: this.state.currentPage + 1
    });
    document.documentElement.scrollTop = 0;
  }

  previousButtonHandle() {
    this.setState((state, props) => ({
      currentPage: state.currentPage - 1
    }));

    this.props.actions.fetchDisposals({
      pageSize: 20,
      pageNo: this.state.currentPage - 1
    });
    document.documentElement.scrollTop = 0;
  }

  render() {
    const { disposals, isFetching } = this.props;

    if (disposals.length === 0) {
      return <NoDisposals />;
    }

    let buttons;

    if (this.state.currentPage > 0) {
      if (disposals.length < 20) {
        buttons = <div style={{ marginTop:10 }}>
          <Button size="small" type="primary" onClick={this.previousButtonHandle}>
            Predchádzajúce pohľadávky
         </Button>
        </div>;
      } else {
        buttons = <div style={{ marginTop: 10 }}>
        <Button size="small" type="primary" onClick={this.previousButtonHandle}>
          Predchádzajúce pohľadávky
         </Button>
        <Button size="small" style={{ float: 'right' }} type="primary" onClick={this.nextButtonHandle}>
          Ďalšie pohľadávky
        </Button>
        </div>;
      }
    } else {
      if (disposals.length < 20) {
        buttons = <div></div>;
      } else {
        buttons = <div style={{ marginTop: 10 }}>
          <Button size="small" style={{ float: 'right' }} type="primary" onClick={this.nextButtonHandle}>
            Ďalšie pohľadávky
         </Button>
        </div>;
      }
    }

    return (
      <div>
        <DisposalList
          isFetching={isFetching}
          items={disposals}
        />
       
        {buttons}
        
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/disposals/containers/DisposalsContainer.js